import React from "react";

function phoneNumberLink(phoneNumber: string) {
  return `tel:${phoneNumber.replace(/\s+/g, "")}`;
}

export default phoneNumberLink;
